'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const TableRow = forwardRef(({ className, children, ...props }, ref) => {
    return (_jsx("tr", { ref: ref, className: cn('border-b border-b-metal-50 transition-colors hover:bg-metal-25 data-[state=selected]:bg-metal-50 dark:border-b-metal-800 dark:hover:bg-metal-800', className), ...props, children: children }));
});
TableRow.displayName = 'TableRow';
export { TableRow };
